"use client";
import {
  closeLast,
  DialogsComponent,
  hasOpenDialog,
  openConfirmDialog,
} from "@/src/components/dialogs";
import { CONFIG, USER } from "@/src/data/globalVariables";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import moment from "moment";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Loading from "../components/loading";
import { ServerData } from "../data/allTypes";
import apiFetch from "../utils/apiFetch";
import { flutterPost } from "../utils/utils";
import AiButton from "./aiTasks/aiButton";

const queryClient = new QueryClient();

export default function PageRoot({ children }: { children: any }) {
  const [serverData, setServerData] = useState<ServerData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const pathName = usePathname();

  useEffect(() => {
    initializeWindowFunctions();
    parseServerData();
  }, []);

  async function parseServerData() {
    let data = await localSessionData();

    if (!data?.loggedInUser && pathName != "/login")
      return (window.location.href = "/login");

    // if (
    //   !data?.loggedInUser?.role?.permissions?.includes(pathName as any) &&
    //   pathName != "/login"
    // )
    //   return (window.location.href = "/login");

    CONFIG.set(data?.referentielConfig);
    USER.set(data?.loggedInUser);

    setServerData(data);
  }

  async function localSessionData() {
    let data = sessionStorage.getItem("serverData");
    if (data) return JSON.parse(data) as ServerData;
    setIsLoading(true);
    let serverData = await apiFetch("general", "getServerData", {
      req: null as any,
      res: null as any,
    });
    sessionStorage.setItem("serverData", JSON.stringify(serverData));

    setIsLoading(false);
    return serverData;
  }

  return (
    <QueryClientProvider client={queryClient} key={USER.get()?.id}>
      <ToastContainer />
      <DialogsComponent></DialogsComponent>
      {serverData == null ? (
        <div className="center p20">
          {isLoading == true && <Loading></Loading>}
        </div>
      ) : (
        children
      )}
      <AiButton onChange={() => {}}></AiButton>
    </QueryClientProvider>
  );
}

function initializeWindowFunctions() {
  (window as any).back = () => {
    console.log("Going back!");
    if (hasOpenDialog()) {
      closeLast();
    } else {
      openConfirmDialog({
        title: "Quitter l'application",
        content: "Voulez-vous vraiment quitter l'application?",
        onConfirm: () => {
          flutterPost({ type: "close_app" });
        },
      });
    }
  };

  (window as any).help = () => {
    flutterPost({ type: "help" });
  };

  (window as any).onTokenReceived = async function (
    token: string | null | undefined
  ) {
    if (!token) return;
    let user = USER?.get();
    if (!user) return;
    if (user.token == token) return;
    user.token = token;
    user.lastTokenDate = moment().format("YYYY-MM-DD HH:mm:ss");
    try {
      await apiFetch(
        "users",
        "addOne",
        { user },
        "Erreur lors de la mise à jour du token"
      );
    } catch (e) {
      console.log(e);
    }
  };
}
